import { render, staticRenderFns } from "./TwoFactorSet.vue?vue&type=template&id=006c7300&scoped=true&"
import script from "./TwoFactorSet.vue?vue&type=script&lang=js&"
export * from "./TwoFactorSet.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorSet.vue?vue&type=style&index=0&id=006c7300&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006c7300",
  null
  
)

export default component.exports